var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5a1 1 0 0 0-1-1h-3.337c-.245 0-.367 0-.482-.028a1 1 0 0 1-.29-.12c-.1-.061-.187-.148-.36-.32l-.828-.83c-.26-.258-.39-.388-.54-.481a1.5 1.5 0 0 0-.434-.18C13.556 2 13.373 2 13.006 2h-2.012c-.367 0-.55 0-.723.041a1.5 1.5 0 0 0-.433.18c-.152.093-.282.223-.54.482l-.83.828c-.172.173-.259.26-.36.322a1 1 0 0 1-.289.12C7.704 4 7.582 4 7.337 4H4a1 1 0 0 0 0 2h16a1 1 0 0 0 1-1Zm-2 3H5v7.7c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h4.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.22 19 17.38 19 15.7V8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete24);
export default __webpack_public_path__ + "static/media/delete_24.d87c1a4d.svg";
export { ForwardRef as ReactComponent };